import { ReactElement } from 'react';
import { useModal } from './Modal';
import { useTranslation } from '@/hooks/useTranslation';
import clsx from 'clsx';
import { TSvgIcon } from '@/components/icons';

export enum ConfirmationModalType {
  Info = 'info',
  Danger = 'danger',
}

const TypeToCtaClass = {
  [ConfirmationModalType.Info]: '',
  [ConfirmationModalType.Danger]: 'danger',
};

function ConfirmationModal({
  Illustration,
  title,
  description,
  callbackIfConfirmed,
  type,
}: {
  Illustration?: TSvgIcon;
  title?: string;
  description: string | ReactElement;
  callbackIfConfirmed: () => void;
  type?: ConfirmationModalType;
}) {
  const modal = useModal();
  const { t } = useTranslation();

  const confirm = () => {
    callbackIfConfirmed();
    modal.closeModal();
  };

  return (
    <>
      <div className="flex flex-col gap-2 items-center p-8">
        {Illustration && (
            <Illustration className="h-30 w-30" aria-hidden="true" />
          )}

        <div className="text-center">
          {!!title && <h5>{title}</h5>}
          {description}
        </div>
      </div>

      <div className="flex justify-end items-center gap-4 border-t p-6">
        <button className="secondary" onClick={() => modal.closeModal()}>
          {t('global:cancel')}
        </button>
        <button
          className={clsx('primary danger', type && TypeToCtaClass[type])}
          onClick={confirm}
        >
          {t('global:confirm')}
        </button>
      </div>
    </>
  );
}

export const useConfirmationModal = () => {
  const modal = useModal();

  const openConfirmationModal = ({
    titleBar,
    Illustration,
    title,
    description,
    callbackIfConfirmed,
    type,
  }: {
    titleBar: string;
    Illustration?: TSvgIcon;
    title?: string;
    description: string | ReactElement;
    callbackIfConfirmed: () => void;
    type?: ConfirmationModalType;
  }) => {
    modal.openModal(
      <ConfirmationModal
        title={title}
        description={description}
        Illustration={Illustration}
        callbackIfConfirmed={callbackIfConfirmed}
        type={type}
      />,
      {
        title: titleBar,
        isFullscreen: false,
        displayTitleBar: true,
        padding: 'p-0',
      },
    );
  };

  return {
    openConfirmationModal,
  };
};
